import { EditFieldKind, GenericEditField } from "../DTO/GenericDTO"

export const PersonSalutationEditFields: GenericEditField[][] = [
  [

    {
      title: 'Geschlecht',
      key1: 'tag',
      key2: 'sex',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m6',
    },
    {
      title: 'Anrede',
      key1: 'tag',
      key2: 'Anrede',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m6',
    },
  ],
  [
    
    {
      title: 'Anrede (Anschrift)',
      key1: 'tag',
      key2: 'salutation',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m6',
    },
    {
      title: 'Anrede (Brief)',
      key1: 'tag',
      key2: 'Briefanrede',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m6',
    },
  ],
  [
    {
      title: 'Titel',
      key1: 'tag',
      key2: 'Titel',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m6',
    },
    {
      title: 'Akademischer Grad',
      key1: 'tag',
      key2: 'academic_degree',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m6',
    },
  ],
]

export const PersonComunicationEditFields: GenericEditField[][] = [
  [
    {
      title: 'Sperre Mailing',
      key1: 'sales',
      key2: 'nomail',
      kind: EditFieldKind.checkTF,
      className: 'w3-col s12 m4',
    },
  ]
]

export const PersonPositionEditFields: GenericEditField[][] = [
  [
    {
      title: 'Funktion',
      key1: 'info',
      key2: 'Funktion',
      kind: EditFieldKind.string,
      className: 'w3-col s12 m6',
    },
    {
      title: 'Funktion Homogen',
      key1: 'tag',
      key2: 'FUNKTIONHOMOGEN',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m6',
    },
  ],
  [
    {
      title: 'Abteilung',
      key1: 'info',
      key2: 'Abteilung',
      kind: EditFieldKind.string,
      className: 'w3-col s12 m6',
    },
    {
      title: 'Abteilung Homogen',
      key1: 'tag',
      key2: 'ABTEILUNGHOMOGEN',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m6',
    },
  ],
]

export const PersonNotesEditFields: GenericEditField[][] = [
  [
    {
      title: 'Bemerkungen',
      key1: 'info',
      key2: 'description',
      kind: EditFieldKind.textArea,
    },
  ],
  [
    {
      title: 'Rohinput',
      key1: 'data',
      key2: 'input',
      kind: EditFieldKind.textArea,
    },
  ],
  [
    {
      title: 'Vertriebsinfo',
      key1: 'tag',
      key2: 'marketingRole',
      kind: EditFieldKind.multitag,
      className: 'w3-col s12 m6'
    },
    {
      title: 'Herkunft',
      key1: 'tag',
      key2: 'sales_origin',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m6'
    },
    {
      title: 'Gruppeninfo',
      key1: 'tag',
      key2: 'groupInfo',
      kind: EditFieldKind.tag,
      className: 'w3-col s12 m12'
    },
  ],
  [
    {
      title: 'Vertriebsinfo',
      key1: 'data',
      key2: 'marketingInfo',
      kind: EditFieldKind.textArea,
    },
  ]

]

export const PersonPhoneEditFields: GenericEditField[][] = [
  [
    {
      title: 'Telefon (Geschäftlich)',
      key1: 'info',
      key2: 'Telefon1',
      kind: EditFieldKind.string,
    },
  ],
  [
    {
      title: 'Mobil (Geschäftlich)',
      key1: 'info',
      key2: 'Mobil1',
      kind: EditFieldKind.string,
    },
  ],
]

export const PersonPrivateInfoEditFields: GenericEditField[][] = [
  [
    {
      title: 'Rufname',
      key1: 'info',
      key2: 'call_sign',
      kind: EditFieldKind.string,
    },
    {
      title: 'Geburtsdatum',
      kind: EditFieldKind.date, 
      key1: 'data',
      key2: 'birthdate',
    },
    {
      title: 'Familienstand',
      key1: 'tag',
      key2: 'marital_status',
      kind: EditFieldKind.tag,
    },
    {
      title: 'E-Mail (Privat)',
      key1: 'info',
      key2: 'PRIVATEMAIL',
      kind: EditFieldKind.string,
    },
    {
      title: 'Telefon (Privat)',
      key1: 'privateInfo',
      key2: 'phone',
      kind: EditFieldKind.string,
    },
    {
      title: 'Mobil (Privat)',
      key1: 'privateInfo',
      key2: 'mobile',
      kind: EditFieldKind.string,
    },
    {
      title: 'Private URL',
      key1: 'privateInfo',
      key2: 'url',
      kind: EditFieldKind.string,
    },
    {
      title: 'Anmerkungen',
      key1: 'privateInfo',
      key2: 'conspicuous_info',
      kind: EditFieldKind.string,
    },
    {
      title: 'Privat Bemerkungen',
      key1: 'privateInfo',
      key2: 'description',
      kind: EditFieldKind.textArea,
    },
    {
      title: 'Lieblingsfarbe',
      key1: 'privateInfo',
      key2: 'favorite_color',
      kind: EditFieldKind.textArea,
      encrypt: true,
    },
  ]
]

export const PersonPrivateAddressEditFields: GenericEditField[][] = [
  [
    {
      title: 'Straße',
      key1: 'privateInfo',
      key2: 'street',
      kind: EditFieldKind.string,
    },
    {
      title: 'Postleitzahl',
      key1: 'privateInfo',
      key2: 'postalcode',
      kind: EditFieldKind.string,
    },
    {
      title: 'Stadt',
      key1: 'privateInfo',
      key2: 'town',
      kind: EditFieldKind.string,
      className: 's12 m8 l8',
    },
    {
      title: 'Bundesland',
      key1: 'tag',
      key2: 'federalstatePrivate',
      kind: EditFieldKind.tag,
    },
    {
      title: 'Land',
      key1: 'tag',
      key2: 'countryPrivate',
      kind: EditFieldKind.tag,
    },
  ]
]

export const PersonMiscEditFields: GenericEditField[][] = [
  [
    {
      title: 'Personennummer',
      key1: 'NA',
      key2: 'NA',
      kind: EditFieldKind.personNumber,
      className: 'w3-col s12 m4',
    },
    {
      title: 'Weihnachtsbrief Check',
      key1: 'sales',
      key2: 'christmasletter_check',
      kind: EditFieldKind.checkTF,
    },
    {
      title: 'VIP',
      key1: 'sales',
      key2: 'vip',
      kind: EditFieldKind.checkTF,
    },
    {
      title: 'Newsletter',
      key1: 'sales',
      key2: 'newsletter',
      kind: EditFieldKind.checkTF,
    },
    {
      title: 'Kein Newsletter',
      key1: 'sales',
      key2: 'no_newsletter',
      kind: EditFieldKind.checkTF,
    },
    {
      title: 'Löschwunsch nach DSGVO',
      key1: 'dsgvo',
      key2: 'delete_check',
      kind: EditFieldKind.checkTF,
    },
  ]
]

export const PersonEditFields: GenericEditField[][] = [
  [

    
    {
      title: 'Private Adresse',
      kind: EditFieldKind.copyPersonAddress,
      className: 's12 m6 l6',
    },
    
    
    
    
    {
      title: 'Land',
      key1: 'privateInfo',
      key2: 'country',
      kind: EditFieldKind.string,
    },
    
    
    {
      title: 'Postfach',
      key1: 'privateInfo',
      key2: 'mailbox',
      kind: EditFieldKind.string,
      className: 's12 m6 l6',
    },
    {
      title: 'Postfach Plz',
      key1: 'privateInfo',
      key2: 'mailbox_postalcode',
      kind: EditFieldKind.string,
      className: 's12 m6 l6',
    },
    
    {
      title: 'Rohinput',
      key1: 'data',
      key2: 'input',
      kind: EditFieldKind.textArea,
    },
    
  
    {
      title: 'Persönliche Informationen',
      kind: EditFieldKind.block,
      className: 's12 m6 l6',
    },
  
    
  
    {
      title: 'Akademischer Grad',
      key1: 'info',
      key2: 'academic_degree',
      kind: EditFieldKind.string,
    },
  
    
  
  
    {
      title: 'Familienstand',
      key1: 'privateInfo',
      key2: 'marital_status',
      kind: EditFieldKind.string,
    },
  
    
    {
      title: 'Anrede',
      key1: 'data',
      key2: 'salutation',
      kind: EditFieldKind.string,
    },
    
    
    
    {
      title: 'Marketing',
      kind: EditFieldKind.block,
      className: 's12 m6 l6',
    },
    
  
    
    {
      title: 'Trainer Einstellungsdatum',
      key1: 'trainer',
      key2: 'staffed',
      kind: EditFieldKind.string,
      className: 's12 m8 l8',
    },
    {
      title: 'Personalnummer',
      key1: 'trainer',
      key2: 'personal_number',
      kind: EditFieldKind.string,
      className: 's12 m4 l4',
    },
  ]
  
]
